// FIXME: remove after frontend-components >= 32.1.0 is available
export default function propertyOrNull(obj, ...props) {
    return props.reduce((obj, property) => {
        if (obj) {
            return obj[property] !== undefined ? obj[property] : null;
        } else {
            return null;
        }
    }, obj);
}



// WEBPACK FOOTER //
// ./src/web/js/contest/utils/property-or-null.js